import { render, staticRenderFns } from "./mycommunity-notamember.vue?vue&type=template&id=2c6cf686&"
import script from "./mycommunity-notamember.vue?vue&type=script&lang=js&"
export * from "./mycommunity-notamember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports